import React from 'react';
import { Eyebrow, SectionLead, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { deliverables } from '../../data/content';
export function Deliverables() {
  return <SectionShell tone="cream" data-id="element-125" data-mp="merzltwh1a8n">
      <Eyebrow data-id="element-126" data-mp="mbnla3paky49">Entrega inmediata</Eyebrow>
      <SectionTitle data-id="element-127" data-mp="qeu0i0udtzmv">¿Qué recibirás inmediatamente después de tu compra?</SectionTitle>
      <SectionLead data-id="element-128" data-mp="1e564j0mibc86">
        Desde el primer minuto tendrás un sistema completo de toma de decisiones clínicas listo para
        tu siguiente consulta.
      </SectionLead>

      <div className="mt-8 space-y-3.5" data-id="element-129" data-mp="1j1wssb8gte4o">
        {deliverables.map(item => <article key={item.title} className="flex gap-3.5 rounded-2xl border border-navy-100 bg-white p-4 sm:gap-4 sm:p-5" data-id="element-130" data-mp="153yipi16g3uz">
            <span className="text-2xl leading-none" aria-hidden="true" data-id="element-131" data-mp="3pu7eb8fso804">
              {item.emoji}
            </span>
            <div className="min-w-0" data-id="element-132" data-mp="3uubm8a2mzueq">
              <h3 className="font-display text-[17.5px] font-bold leading-snug text-navy-900 sm:text-xl" data-id="element-133" data-mp="3ur7a8qixjudi">
                {item.title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-navy-700/80 sm:text-[14.5px]" data-id="element-134" data-mp="9g4nix3a5gox">
                {item.text}
              </p>
            </div>
          </article>)}
      </div>

      <p className="mx-auto mt-8 max-w-xl text-center font-display text-[18px] font-bold leading-snug text-navy-900 sm:text-[22px]" data-id="element-135" data-mp="jcg1rsmfkgm0">
        Cualquier paciente renal que entre a tu consultorio tendrá una ruta clínica clara antes de
        terminar la consulta.
      </p>

      <div className="mt-7" data-id="element-136" data-mp="173d1m70ybngw">
        <CtaButton label="Quiero mi sistema de decisiones" sub="Algoritmos, protocolos, rutas y checklists en un solo lugar" data-id="element-137" data-mp="171ijf0h2e9gi" />
      </div>
    </SectionShell>;
}